export type { ComponentSwitcherProps } from './ComponentSwitcher';

export { ComponentSwitcher } from './ComponentSwitcher';
export { useComponentSwitcher } from './ComponentSwitcher.Context';
